import { ExplytStoreItem } from "./ExplytStoreItem";
import { Button } from "../Common/Elements/Button";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingCircle, LoadingCircleBlack } from "../Common/Loading/LoadingPlaceholder";
import { PopupContentProps } from "../Common/Elements/Popup";
import { lytSmall } from "../Common/Icons/Icons";
import { ListEntry } from "../Common/Elements/ListEntry";
import { getWallets, postSubscribe } from "../../communication/communication";
import { NotificationsContext } from "../../App";
import { SetBalanceContext } from "../Common/Authorization/UserProvider";
import { Wallet } from "../../types/explyt";
import { loading } from "../../communication/wrapped";

export type ExplytStorePurchaseProps = {
    item: ExplytStoreItem,
    back: () => void
}

function ExplytStorePurchase(props: ExplytStorePurchaseProps) {
    const { t } = useTranslation()
    const [wallets, setWallets] = useState(loading<Wallet[]>(null!));
    const setBalance = useContext(SetBalanceContext);
    const addNotification = useContext(NotificationsContext)
    const lytBalance = wallets.data?.find(w => w.currency === "Credits")?.balance;

    const buttonText = <>{`${t("purchaseFor")} ${props.item.price} ${props.item.currency}`}</>
    const bottomText = `${t("balance")}: ${lytBalance} Test Credits`

    const [purchaseButtonContent, setPurchaseButtonContent] = useState(buttonText)

    useEffect(() => {
        getWallets().then(setWallets)
    }, [props]);

    const purchase = () => {
        setPurchaseButtonContent(<LoadingCircleBlack className={"loading-circle-big"} />)
        postSubscribe(props.item.id, "1", "Credits", null).then(r => {
            if (r.statusCode !== 200) {
                addNotification(t("errorOccurred"));
                return;
            }
            setPurchaseButtonContent(buttonText);
            props.back();
            setBalance(r.data!);
        })

    }

    if (lytBalance === undefined) {
        return <div className="flex-center">
            <LoadingCircle className="loading-circle-big" />
        </div>
    }

    const sufficientBalance = props.item.price <= lytBalance;

    return <div style={{ display: "grid", gridTemplateRows: "1fr 8rem", height: "100%" }}>
        <span className="font-white small-margin flex-column small-padding-top">
            <div className="flex-x-center small-margin-bottom">
                <div style={{ height: "7rem", width: "7rem" }}>
                    {props.item.imageElement}
                </div>
            </div>
            <div className="flex-x-center" style={{ marginTop: "0.7rem" }}>
                <span className={"font-white big-font"}>{props.item.name}</span>
            </div>
            <div className="flex-x-center" style={{ marginTop: "0.4rem" }}>
                <span className={"font-gray medium-font"}>{props.item.description}</span>
            </div>
            <div className="entry-light-bg" style={{ padding: "0.5rem 0 0.5rem 0", marginTop: "1.5rem" }}>
                <ListEntry
                    imageElement={<div className="flex-center">{lytSmall("var(--color-main)")}</div>}
                    title={<span className="big-font font-white no-break">{`${props.item.name}`}</span>}
                    subscript={<span className="medium-font font-gray no-break">{`${props.item.price} Test Credits`}</span>}
                    rightText={<></>}
                />
            </div>
        </span>
        <div className="small-margin">
            <Button
                backgroundColor={sufficientBalance ? "var(--color-main)" : "var(--progress-bar-button-bg)"}
                onClick={sufficientBalance ? purchase : () => { }}
                textColor={sufficientBalance ? "black" : "var(--font-dim)"}
                text={purchaseButtonContent}
            />
            <div style={{ height: "1.5rem" }} />
            <div className="flex-x-center">
                <span className="font-gray fw-400 medium-font text-center"> {bottomText} </span>
            </div>
        </div>
    </div>
}

export function ExplytStorePurchasePopup(props: PopupContentProps<{ item: ExplytStoreItem }>) {
    return <div className={props.isOpen ? "bg-black" : "hidden"}>
        <ExplytStorePurchase item={props.data.item} back={props.closePopup} />
    </div>
}